import type { Dispatch} from 'umi';
import { connect, useIntl } from 'umi';

import type { InquiryState } from '@/models/inquiry';
import styles from './index.less';

interface InquiryCountdowntProps {
  inquiry: InquiryState;
  dispatch: Dispatch;
};

const InquiryCountdown: React.FC<InquiryCountdowntProps> = ({
  inquiry,
  dispatch
}) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.Inquiry.InquiryCountdown', intl.formatMessage);

  return (
    inquiry.countdown
      ? <div className={styles.inquiryCountdown}>
          <span className={styles.red}>{t('t0', '咨询中')}</span>
          <span>
            <span className={styles.red}>
              {
                inquiry.countdown > 60
                  ? <span>{Math.floor(inquiry.countdown / 60)}{t('t1', '分钟')}</span>
                  : <span>{inquiry.countdown}{t('t2', '秒')}</span>
              }
            </span>
            {t('t3', '后咨询结束')}
          </span>
        </div>
      : null
  )
};

const mapToProps = ({ inquiry }: { inquiry: InquiryState }) => {
  return {
    inquiry
  }
}
                  
export default connect(mapToProps)(InquiryCountdown);
